import {
  AlertDialog,
  AlertProps as AlertPropsChakra,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  Icon,
  Flex,
  Text,
  Box,
  Link,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import {
  IoAlertCircleOutline,
  IoCheckmarkCircleOutline,
} from "react-icons/io5";

interface AlertProps extends AlertPropsChakra {
  isConfirmAlert?: boolean;
  closeButtonText?: string;
  confirmButtonText?: string;
  isOpen: boolean;
  leastDestructiveRef: any;
  onClose?: () => void;
  onConfirm: () => void;
  title: string;
  messageBody?: string | ReactNode;
  urlBody?: string;
  children?: ReactNode;
  bgColor?: string;
  messageBodyPosition?: string;
  isLoading?: boolean;
}

function Alert({
  urlBody,
  isConfirmAlert,
  children,
  closeButtonText,
  confirmButtonText = "Pronto",
  isOpen,
  onClose,
  onConfirm,
  leastDestructiveRef,
  title,
  messageBody,
  messageBodyPosition,
  bgColor = "#1890FF",
  isLoading,
  ...rest
}: AlertProps) {
  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={() => onClose}
      leastDestructiveRef={leastDestructiveRef}
      motionPreset="slideInBottom"
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent display="flex" flexDir="column" borderRadius="2" {...rest}>
          <AlertDialogHeader margin="0" p="0" fontSize="1rem" fontWeight="bold">
            <Flex marginTop="1rem" ml={4}>
              <Icon
                as={
                  isConfirmAlert
                    ? IoCheckmarkCircleOutline
                    : IoAlertCircleOutline
                }
                w={7}
                h={7}
                color={isConfirmAlert ? "#52C41A" : "#FAAD14"}
                mr={3}
              />
              <Text fontSize="1.1rem">{title}</Text>
            </Flex>
          </AlertDialogHeader>

          <AlertDialogBody
            margin="0"
            p="0"
            h="1rem"
            marginTop="1rem"
            display="flex"
            w="100%"
            alignItems="center"
            flexDir="column"
            justifyContent={messageBodyPosition ? messageBodyPosition : "center"}
          >
            {messageBody && (
              <Box ml={14} mr={6}>
                <Text textAlign="start">{messageBody}</Text>
                <Link
                  color="blue.200"
                >
                  {urlBody}
                </Link>
              </Box>
            )}
            {children}
          </AlertDialogBody>

          <AlertDialogFooter
            h="5rem"
            w="100%"
            display="flex"
            justifyContent="flex-end"
          >
            {closeButtonText && (
              <Button
                ref={leastDestructiveRef}
                variant="outline"
                m="0 1rem 3rem 0"
                color="black"
                borderRadius="3"
                marginTop="3rem"
                _active={{
                  filter: "brightness(.6)",
                }}
                _focus={{}}
                onClick={onClose}
              >
                {closeButtonText}
              </Button>
            )}
            <Button
              m="0 0 3rem 0"
              bgColor={bgColor}
              color="white"
              borderRadius="3"
              marginTop="3rem"
              transition="filter .2s"
              _hover={{
                transition: "filter .2s",
                filter: "brightness(.9)",
              }}
              _active={{
                filter: "brightness(.6)",
              }}
              _focus={{}}
              onClick={onConfirm}
              isDisabled={isLoading}
              isLoading={isLoading}
            >
              {confirmButtonText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export { Alert };